import React from 'react'
import { clsx } from 'clsx'

type BaseRadio = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export type InputRadioProps = Omit<BaseRadio, 'type' | 'checked' | 'onChange'> & {
  value: string
  checked: boolean
  onChange: (value: string) => void
  label?: string
}

export const InputRadio = ({ value, checked, onChange, label, ...rest }: InputRadioProps) => {
  return (
    <div className="tw-flex tw-items-center tw-text-sm">
      <input type="radio" className="tw-sr-only" checked={checked} onChange={() => onChange(value)} {...rest} />
      <div
        className={clsx(
          'tw-w-5 tw-h-5 tw-rounded-full tw-border tw-border-slate-300 tw-mr-2',
          'tw-flex tw-items-center tw-justify-center',
          'tw-transition-colors tw-duration-200',
          {
            'tw-bg-slate-300/40': !checked,
            'tw-bg-primary-500 tw-border-primary-500': checked,
          },
        )}
        onClick={() => onChange(value)}
      >
        {checked && <div className="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-white" />}
      </div>
      {label && (
        <label className="tw-text-white" onClick={() => onChange(value)}>
          {label}
        </label>
      )}
    </div>
  )
}
